import React from 'react';

function Index({ page }) {
  const Component = React.useMemo(() => {
    return React.lazy(() => import(`pages/${page}`));
  }, [page]);
  return (
    <React.Suspense>
      <Component />
    </React.Suspense>
  );
}

export default Index;
